import { GET_EDUCATION, GET_INTRO, GET_SKILLS, GET_SOCIAL, GET_JOURNEY, INFO_ERROR, GET_PROGRESS_BARS } from '../types'

export default (state, action) => {

    const { type, payload } = action;

    switch(type){
        case GET_EDUCATION: 
        return {
            ...state,
            education: payload,
            loading: false
        }
        case GET_INTRO: 
        return {
            ...state,
            intro: payload,
            loading: false
        }
        case GET_SKILLS: 
        return {
            ...state,
            skills: payload,
            loading: false
        }
        case GET_PROGRESS_BARS: 
        return {
            ...state,
            progressBars: payload,
            loading: false
        }
        case GET_SOCIAL: 
        return {
            ...state,
            social: payload,
            loading: false
        }
        case GET_JOURNEY: 
        return {
            ...state,
            journey: payload,
            loading: false
        }

        case INFO_ERROR: 
        return {
            ...state,
            journey: [],
            social: [],
            skills: [],
            intro: [],
            education: [],
            loading: false
        }
        default: return state
    }
}